import { AppState } from '../../root-reducer';

export const selectSatelliteOrders = (state: AppState) => state.tasksDomain.orders;

export const selectActiveOrder = (state: AppState) => state.tasksDomain.activeOrder;
